import styled from 'styled-components'
import { FlagBadge } from '.'

type Props = {
  promotion: { audience?: 'global' | 'targeted' }
  className?: string
}

export const TargetedJustForYouFlag = ({ promotion, className }: Props) => {
  if (promotion.audience === 'targeted') {
    return <RetailerFlag type="justForYou" className={className} />
  }
  return null
}

const RetailerFlag = styled(FlagBadge)`
  position: absolute;
  top: -0.5rem;
  left: -0.5rem;
  z-index: 2;
`
